import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import logo from '../../../assets/images/doverunnerIcon.png';
import logoWhite from '../../../assets/images/drwhite.png';
import logoPurple from '../../../assets/images/drpurple.png';
import { AppURL } from '../../../utility/AppURL';
import LanguageSelector from '../languageselector';

export default function IntegrationPopup() {
    const { t } = useTranslation();
    return (
        <div className="fixed inset-0 z-10 flex items-center justify-center bg-black/60">
            <div className="bg-white rounded-2xl shadow-xl w-[520px] text-center h-[720px] py-[70px] px-[80px] relative">
                <h2 className="text-[24px] font-bold text-dr-primary">{t('integration_popup_title')}</h2>
                <div>
                    <div className="flex justify-center items-center my-[100px]">
                        <img src={logo} alt="DoveRunner Logo" width={200} />
                    </div>
                    <p className="text-sm text-gray-600 whitespace-pre-line">{t('integration_popup_content')}</p>
                </div>
                <div className="absolute bottom-[40px] left-0 right-0 z-20 px-[80px]">
                    <div className="flex items-center justify-center gap-4">
                        <Button variant="outlined" className="border-dr-primary text-dr-primary h-[40px] rounded-[12px]" fullWidth href={AppURL.doverunnerLogin}>
                            <img src={logoPurple} alt="DoveRunner Logo" width={18} className="mr-2" />
                            {t('integration_popup_login_button')}
                        </Button>
                        <Button variant="contained" className="bg-dr-primary text-white h-[40px] rounded-[12px]" fullWidth href={AppURL.doverunnerIntegration}>
                            <img src={logoWhite} alt="DoveRunner Logo" width={18} className="mr-2" />
                            {t('integration_popup_integration_button')}
                        </Button>
                    </div>
                    <div className="flex justify-end mt-1">
                        <LanguageSelector />
                    </div>
                </div>
            </div>
        </div>
    );
}
